import { Box, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";

export default function InputLabel({
  label,
  color = "inherit",
  size = "small",
  icon = null,
  iconSize = null,
  sx = {},
  ...props
}) {
  /*
  If you use a currentColor .svg, the enabled/disabled colors will be the same as the text color.
  If you provide only an icon (no text), the button will be square.
  */
  const colors = useColors();

  const sizeMap = {
    small: {
      fontSize: "12px",
      height: "20px",
      paddingX: "10px",
      borderRadius: "10px",
      iconSize: 14,
    },
    medium: {
      fontSize: "12px",
      height: "24px",
      paddingX: "10px",
      borderRadius: "12px",
      iconSize: 16,
    },
    large: {
      fontSize: "14px",
      height: "32px",
      paddingX: "10px",
      borderRadius: "16px",
      iconSize: 20,
    },
  };

  const sizeConfig = sizeMap[size];

  return (
    <Box
      sx={{
        position: "relative",
        textTransform: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: sizeConfig.height,
        paddingX: sizeConfig.paddingX,
        fontSize: sizeConfig.fontSize,
        width: "fit-content",
        minWidth: "24px",
        borderRadius: sizeConfig.borderRadius,
        color: colors.text_secondary,
        border: "1px solid " + colors.grey_300,
        ...sx,
      }}
      {...props}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={0.7}
        justifyContent="center"
        whiteSpace="nowrap"
      >
        {icon && (
          <SvgToIcon
            IconLogo={icon}
            width={iconSize || sizeConfig.iconSize}
            height={iconSize || sizeConfig.iconSize}
          />
        )}
        <Typography variant="caption">{label}</Typography>
      </Box>
    </Box>
  );
}
